import {
  HttpValidationProblemDetails,
  ProblemDetails,
} from "../clients/BackOfficeApi";

export type ValidationErrorModel<T extends object> = {
  [key in Capitalize<Extract<keyof T, string>>]?: string[];
} & Record<string, string[]>;

export interface BadRequestError<
  T extends object,
> extends HttpValidationProblemDetails {
  status: 400;
  errors: ValidationErrorModel<T>;
}

interface InternalServerError extends ProblemDetails {
  status: 500;
  detail: string;
}

export const isApiError = (error: unknown): error is ProblemDetails =>
  typeof error === "object" &&
  error !== null &&
  "status" in error &&
  "title" in error &&
  "type" in error;

export const isBadRequest = <T extends object = object>(
  error: unknown,
): error is BadRequestError<T> =>
  isApiError(error) &&
  error.status === 400;

export const isInternalServerError = (
  error: unknown,
): error is InternalServerError =>
  isApiError(error) &&
  error.status === 500;
